import type { GamePlayerProjectionTrading } from '@library/types/trading';
import type { ProjectionsAndScoresAPIResponse } from '@library/types/projection';
import type { RankDrawerProjectionsRequest } from '@library/types/rankDrawer';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';
import { getPlayerModalProjections } from '@bo-utils/playerModal';

const { admin } = apiPaths;

export const rankDrawerApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRankDrawerProjections: build.query<
      Array<GamePlayerProjectionTrading>,
      RankDrawerProjectionsRequest
    >({
      query: ({
        fromDate,
        leagueId,
        statTypeId,
        statuses,
        gameIds,
        teamIds
      }) => ({
        url: `${admin}projections`,
        method: 'GET',
        params: {
          from_date: fromDate,
          league_id: leagueId,
          page: 1,
          per_page: 10000,
          stat_type_id: statTypeId,
          statuses,
          game_ids: gameIds,
          teams: teamIds
        },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      keepUnusedDataFor: 0,
      providesTags: (_result, _error, arg) => [
        { type: 'Rankings', id: arg.statTypeId }
      ],
      transformResponse: (response: ProjectionsAndScoresAPIResponse) =>
        getPlayerModalProjections(response)
    })
  })
});

export const { useGetRankDrawerProjectionsQuery } = rankDrawerApi;
